import { FC } from "react";
import styles from "./index.module.scss";
import cn from "classnames";

interface SwitchProps {
  value: boolean;
  loading?: boolean;
  onChange?: (val: boolean) => void;
}

const Switch: FC<SwitchProps> = ({
  value,
  loading = false,
  onChange = () => {},
}) => {
  const click = () => {
    if (loading) return;
    onChange(!value);
  };

  return (
    <div
      className={cn("switch", styles.switch, value && styles.active)}
      onClick={click}
    >
      <div className={cn(styles.dot)}>
        <svg
          className={cn(loading ? styles.loading : styles.unloading)}
          viewBox="0 0 1024 1024"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#e1e2e5"
            d="M512 64a32 32 0 0 1 32 32v192a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32zm0 640a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V736a32 32 0 0 1 32-32zm448-192a32 32 0 0 1-32 32H736a32 32 0 1 1 0-64h192a32 32 0 0 1 32 32zm-640 0a32 32 0 0 1-32 32H96a32 32 0 0 1 0-64h192a32 32 0 0 1 32 32zM195.2 195.2a32 32 0 0 1 45.248 0L376.32 331.008a32 32 0 0 1-45.248 45.248L195.2 240.448a32 32 0 0 1 0-45.248zm452.544 452.544a32 32 0 0 1 45.248 0L828.8 783.552a32 32 0 0 1-45.248 45.248L647.744 692.992a32 32 0 0 1 0-45.248zM828.8 195.264a32 32 0 0 1 0 45.184L692.992 376.32a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0zm-452.544 452.48a32 32 0 0 1 0 45.248L240.448 828.8a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0z"
          ></path>
        </svg>
      </div>
    </div>
  );
};

export default Switch;
